module.exports = require('./helpers/bundle-url').getBundleURL('cFItr') + "logo.c51670a8.svg";